import React from 'react';
import { SortDirection } from '@lmt/shared-types';

import sortAscIcon from '@lmt/unicorn-shared/app/icons/sort-asc.svg';
import sortDescIcon from '@lmt/unicorn-shared/app/icons/sort-desc.svg';
import sortIcon from '@lmt/unicorn-shared/app/icons/sort-none.svg';
const style: React.CSSProperties = {
  userSelect: 'none',
};
export const getSortIcon = (sortDirection: SortDirection | null) => (
  <img
    style={style}
    src={
      sortDirection === null
        ? sortIcon
        : sortDirection === SortDirection.Asc
        ? sortAscIcon
        : sortDescIcon
    }
  />
);

export function ScrollToTop(element: Element) {
  element.scrollTop = 0;
}
